export var ElementKind;
(function (ElementKind) {
    ElementKind["Rectangle"] = "rectangle";
    ElementKind["Text"] = "text";
    ElementKind["Image"] = "image";
    ElementKind["Video"] = "video";
    ElementKind["Audio"] = "audio";
    ElementKind["Group"] = "group";
    ElementKind["Ellipse"] = "ellipse";
    ElementKind["Button"] = "button";
    ElementKind["Widget"] = "widget";
    /** Only set when bfl-widget is in bl. Only applied to `element.type` */
    ElementKind["BannerflowLibraryWidget"] = "bannerflowLibraryWidget";
    /** Only set when bfl-widget is on canvas. Only applied to `element.type`, never on `node.kind` */
    ElementKind["BannerflowLibraryWidgetInstance"] = "bannerflowLibraryWidgetInstance";
})(ElementKind || (ElementKind = {}));
